import type { FC, ReactNode } from 'react'

import { useEffect, useRef } from 'react'

const INTERACTIVE = 'a, button, input, textarea, select, label, [role="slider"], [role="button"]'

/**
 * A thin crosshair that replaces the mouse pointer over point-cloud areas marked with data-crosshair.
 */
export const SiteCrosshair: FC = (): ReactNode => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return

        const html = document.documentElement
        const element = ref.current

        html.setAttribute('data-crosshair-ready', '')

        const move = (event: PointerEvent): void => {
            if (!element || event.pointerType !== 'mouse') return

            const target = event.target instanceof Element ? event.target : null
            const on = Boolean(target?.closest('[data-crosshair]')) && !target?.closest(INTERACTIVE)

            element.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0)`
            element.classList.toggle('is-on', on)
        }

        const hide = (): void => {
            element?.classList.remove('is-on')
        }

        document.addEventListener('pointermove', move, { passive: true })
        document.documentElement.addEventListener('pointerleave', hide)

        return () => {
            html.removeAttribute('data-crosshair-ready')
            document.removeEventListener('pointermove', move)
            document.documentElement.removeEventListener('pointerleave', hide)
        }
    }, [])

    return (
        <div ref={ref} className='cf-crosshair site-crosshair' aria-hidden='true'>
            <i />
            <i />
            <i />
            <i />
        </div>
    )
}
